module.exports = __webpack_public_path__ + "img/boingboing.c2a257a3.png";